import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import { useSettings } from '../../../../hooks/useSettings'
import { PartyTierDto } from '../../../../config/finance/financeConfig'
import TierList from '../../../../components/Form/Tier/TierList'
import { PartyTierListItem } from '../../../../components/Form/Tier/PartyTierListItem'
import PartyTierFormContainer, { partyTierValidationSchema } from '../../../../components/Form/Tier/PartyTierFormContainer'

/**
 * Party-specific sales tiers (rates) — only when the Invoices module is active. Reused verbatim
 * from the legacy party forms.
 */
export default function TiersSection(): ReactElement {
    const { values } = useFormikContext<any>()
    const { settings } = useSettings()

    return (
        <TierList<any, PartyTierDto>
            labelPrefixKey="party.edit.tier"
            defaultTierValue={() => ({
                type: 'PARTY_TIER',
                validFrom: DateTime.now().startOf('month').toISODate(),
                validTo: undefined,
                salesRate: '0.00',
                currency: settings.fileScaffold?.currency || 'EUR',
                partyId: values.id,
            })}
            parentValues={values}
            createListItem={(index: number, item: PartyTierDto, editTier) => <PartyTierListItem index={index} item={item} editTier={editTier} />}
            createTierFormContainer={() => <PartyTierFormContainer />}
            validationSchema={partyTierValidationSchema}
        />
    )
}
